import React from 'react';

const LogoutIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="100"
      height="200"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#a)"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5.933 5.04c.207-2.4 1.44-3.38 4.14-3.38h.087c2.98 0 4.173 1.193 4.173 4.173v4.347c0 2.98-1.193 4.174-4.173 4.174h-.087c-2.68 0-3.913-.967-4.133-3.327M10 8H2.412M3.9 5.767 1.667 8 3.9 10.234" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LogoutIcon;
